import { useEffect, useState } from "react";
import useAuth from "../../../../hooks/useAuth";
import UpdateEntity from "../entities/UpdateEntity";
import ServiceAvatarUpdate from "./ServiceAvatarUpdate";
import { useTranslation } from "react-i18next";

const EntityPreferencesPreview = ({
  entityPreferencesData,
  entityData,
}: {
  entityPreferencesData: any;
  entityData: any;
}) => {
  const [t] = useTranslation();
  const { customer_identification, user } = useAuth();

  const [entityDataValues, setEntityDataValues] = useState({
    entity_name: "",
    entity_description: "",
  });

  useEffect(() => {
    setEntityDataValues({
      entity_name: entityData?.entity_name,
      entity_description: entityData?.entity_description,
    });
  }, [entityData]);

  return (
    <div className="flex w-full flex-col items-start gap-4">
      <p className="text-sm text-gray-500">
        {t("dashboard.develop.entityPreferencesPreview.des-01")}
      </p>

      <ServiceAvatarUpdate
        data={entityPreferencesData}
        user_identification={customer_identification}
        entity_identification={user.entity_identification}
        onChangeNewLogo={() => {
          return null;
        }}
      />

      <UpdateEntity data={entityDataValues} />
    </div>
  );
};

export default EntityPreferencesPreview;
